import { HealthScoreOverallStatus } from '../../types';

const normalizeStatus = (
    status: HealthScoreOverallStatus | HealthScoreOverallStatus[],
): HealthScoreOverallStatus => {
    const normalized = Array.isArray(status) ? status : [status];
    if (normalized.every((s) => ['healthy', 'stable'].includes(s))) return 'healthy';
    if (normalized.every((s) => s === 'at_risk')) return 'at_risk';
    if (normalized.every((s) => s === 'critical')) return 'critical';
    return 'unknown';
};

export default normalizeStatus;
